module.exports = __webpack_public_path__ + "static/img/299_TO8_1959_og.710ce0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/299_TO8_1959_og.jpg
// module id = z715
// module chunks = 0